import {
  StyledPrGTemplateCard,
  StyledTemplateCardTitle,
  StyledTemplateCardDetails,
  StyledPrGTemplateCardWrapper,
} from 'modules/predictiveGoals/components/Styled';
import React from 'react';
import noop from 'utils/noop';
import { TEST_IDS } from 'modules/predictiveGoals/constants';
import { Tooltip } from 'ui/tooltip';

export interface TemplateCardProps {
  onClick?: () => void;
  title: string;
  details: string;
  icon: React.ReactNode;
  id: string;
  isDisabled: boolean;
  disabledTooltipContent: string;
}

export const TemplateCard: React.FC<React.PropsWithChildren<TemplateCardProps>> = ({
  icon,
  title,
  details,
  onClick = noop,
  id,
  isDisabled = false,
  disabledTooltipContent,
}) => {
  return (
    <StyledPrGTemplateCardWrapper data-test={`template-card-wrapper-${id}`}>
      <Tooltip
        key={`template-tooltip-${id}`}
        isEnabled={isDisabled}
        tooltipContent={disabledTooltipContent}
      >
        <StyledPrGTemplateCard
          data-test={`template-card-${id}`}
          onClick={() => {
            if (isDisabled) return;
            onClick();
          }}
          data-disabled={isDisabled}
        >
          {icon}
          <div>
            <StyledTemplateCardTitle data-test={`${TEST_IDS.TemplateTitle}-${id}`}>
              {title}
            </StyledTemplateCardTitle>
            <StyledTemplateCardDetails data-test={`${TEST_IDS.TemplateDetails}-${id}`}>
              {details}
            </StyledTemplateCardDetails>
          </div>
        </StyledPrGTemplateCard>
      </Tooltip>
    </StyledPrGTemplateCardWrapper>
  );
};
